<div [class.flex-container]="!isSmall">
  <ng-container *ngFor="let item of items; let i = index;">
    <ng-template [ngTemplateOutlet]="item?.titleTpl.templateRef" [ngTemplateOutletContext]="getOutletContext(item, i)"></ng-template>
    <ng-template *ngIf="isSmall && item === activeTab" [ngTemplateOutlet]="activeTab.contentTpl.templateRef" [ngTemplateOutletContext]="{active: item === activeTab}"></ng-template>
    <span *ngIf="i < items.length - 1 && !isSmall" class="separator">|</span>
  </ng-container>
</div>
<ng-template *ngIf="!isSmall && activeTab !== undefined" [ngTemplateOutlet]="activeTab?.contentTpl.templateRef"></ng-template>
